import { apiSlice } from "../../app/api/apiSlice";

export const destinationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDestinations: builder.query({
      query: () => "/destinations",
      providesTags: ["Destinations"],
    }),
    addDestination: builder.mutation({
      query: (body) => ({
        url: "/destinations",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Destinations"],
    }),
    toggleDestinationVisited: builder.mutation({
      query: (id) => ({
        url: `/destinations/${id}/toggle-visit`,
        method: "PATCH",
      }),
      invalidatesTags: ["Destinations"],
    }),
    updateDestination: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/destinations/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Destinations"],
    }),
    deleteDestination: builder.mutation({
      query: (id) => ({
        url: `/destinations/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Destinations"],
    }),
  }),
});

export const {
  useUpdateDestinationMutation,
  useGetDestinationsQuery,
  useAddDestinationMutation,
  useToggleDestinationVisitedMutation,
  useDeleteDestinationMutation,
} = destinationApiSlice;
